var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.5"},[React.createElement("circle",{"cx":"14.5249","cy":"15.0251","r":"9.5","transform":"rotate(-45 14.5249 15.0251)","stroke":"#E7E5E1","key":0}),React.createElement("rect",{"x":"20.5352","y":"21.7427","width":"1","height":"8","transform":"rotate(-45 20.5352 21.7427)","fill":"#E7E5E1","key":1})]));
}

SearchIcon.defaultProps = {"width":"34","height":"35","viewBox":"0 0 34 35","fill":"none"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
